import React, { useEffect, useState } from 'react';
import { MultipleQuestionnairesBlock } from '@coog/react-components';
import PropTypes from 'prop-types';
import { find, get, isEqual, omit, reduce } from 'lodash-es';
import Action from './Action.presentational';

const SubscriptionPresentational = ({
  blockSubscription,
  isFinishedSalesRoute,
  partialUpdateSalesRouteSubscription,
  strings,
  editField,
  willResetForm,
  onResetForm,
  willSaveForm,
  onSaveForm,
  noSaveNotValid,
  eventChangePersonType,
  i18n,
}) => {
  // SubscriptionBlock
  const [isValidBlock, setIsValidBlock] = useState(false);
  const [answersBlock, setAnswersBlock] = useState();
  let saveAnswersState = {};

  // console.log('answersBlock', answersBlock);

  const handleChangeIsValidBlock = (isValidLocal, id) => {
    let tmpIsValid;

    if (isValidLocal === null && id != null) {
      tmpIsValid = omit(isValidBlock, id);
    } else {
      tmpIsValid = { ...isValidBlock, ...isValidLocal };
    }

    if (!isEqual(tmpIsValid, isValidBlock)) {
      setIsValidBlock(tmpIsValid);
    }
  };

  const handleChangeAnswersBlock = (answersLocal, id) => {
    let tmpAnswers;
    let answersState = answersBlock;

    if (answersLocal === null && id != null) {
      tmpAnswers = omit(answersBlock, id);
    } else {
      if (!answersBlock || (answersBlock && Object.keys(saveAnswersState).length > Object.keys(answersBlock).length)) {
        answersState = saveAnswersState;
      }

      tmpAnswers = { ...answersState, ...answersLocal };
    }

    if (!isEqual(tmpAnswers, answersBlock)) {
      saveAnswersState = tmpAnswers;
      setAnswersBlock(tmpAnswers);
    }

    // eventChangePersonType
    setTimeout(() => {
      if (answersLocal && answersBlock && answersLocal.type_block) {
        const newPersonType = find(get(answersLocal, 'type_block.parts[0].answers'), { code: 'is_person' });

        if (newPersonType) {
          if (answersBlock.type_block) {
            const prevPersonType = find(get(answersBlock, 'type_block.parts[0].answers'), {
              code: 'is_person',
            });

            if (prevPersonType) {
              if (newPersonType.value !== prevPersonType.value) {
                eventChangePersonType(newPersonType.value);
              }
            }
          } else {
            eventChangePersonType(newPersonType.value);
          }
        }
      }
    }, 0);
  };

  const handleEditField = (answersLocal, id) => {
    if (answersBlock) {
      if (answersLocal === null && id != null) {
        editField();
      } else {
        const tmpAnswers = { ...answersBlock, ...answersLocal };

        if (!isEqual(tmpAnswers, answersBlock)) {
          editField();
        }
      }
    }
  };

  const checkIsValid = () => {
    // Check only blocks that are showed
    const valid = reduce(
      blockSubscription.subscribers,
      (acc, block) => {
        const isValid = isValidBlock[block.id];
        return acc && (isValid || isValid === undefined);
      },
      true
    );

    return valid;
  };

  /**
   * check disable next button
   */
  const checkDisableNextButton = () => {
    let disableNextButton;
    if (isFinishedSalesRoute) {
      disableNextButton = true;
    } else {
      disableNextButton = !checkIsValid();
    }
    return disableNextButton;
  };

  useEffect(() => {
    if (willSaveForm) {
      if (checkIsValid()) {
        partialUpdateSalesRouteSubscription({ answers: answersBlock, saveOnly: true })();
        onSaveForm();
      } else {
        noSaveNotValid();
      }
    }
  }, [willSaveForm]);

  // label Button
  const labelNextButton = get(strings, 'editsalesroute.action.button.nextstep.label', 'Etape Suivante');

  return (
    <>
      <MultipleQuestionnairesBlock
        blockData={blockSubscription}
        blockType="subscribers"
        eventEmitter={event => {
          handleChangeIsValidBlock(get(event, 'isValid'), get(event, 'id'));
          handleChangeAnswersBlock(get(event, 'answers'), get(event, 'id'));
          handleEditField(get(event, 'answers'), get(event, 'id'));
        }}
        strings={strings}
        willResetForm={willResetForm}
        onResetForm={onResetForm}
        i18n={i18n}
        canAdd={false}
      />
      <Action
        isDisabledNextButton={checkDisableNextButton()}
        partialUpdateSalesRoute={partialUpdateSalesRouteSubscription({ answers: answersBlock })}
        labelNextButton={labelNextButton}
      />
    </>
  );
};

SubscriptionPresentational.propTypes = {
  blockSubscription: PropTypes.object.isRequired, // eslint-disable-line
  isFinishedSalesRoute: PropTypes.bool, // eslint-disable-line
  partialUpdateSalesRouteSubscription: PropTypes.func.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  editField: PropTypes.func.isRequired,
  willResetForm: PropTypes.bool,
  onResetForm: PropTypes.func,
  willSaveForm: PropTypes.bool,
  onSaveForm: PropTypes.func,
  noSaveNotValid: PropTypes.func,
  eventChangePersonType: PropTypes.func,
  i18n: PropTypes.object,
};

SubscriptionPresentational.defaultProps = {
  isFinishedSalesRoute: false,
  strings: {},
  willResetForm: false,
  onResetForm: () => {},
  willSaveForm: false,
  onSaveForm: () => {},
  noSaveNotValid: () => {},
  eventChangePersonType: () => {},
  i18n: {},
};

export default SubscriptionPresentational;
